// extracted by mini-css-extract-plugin
export default {"quantity-button":"ArtworkCard_quantity-button__61Ynj","quantity-disable":"ArtworkCard_quantity-disable__C6r+U"};